<template>
<div class="tab-pane" v-if="selected">
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    selected () {
      return this.$parent.selectedTab === this
    }
  },
  beforeCreate () {
    this.$parent.addTab(this)
  },
  destroyed () {
    this.$parent.removeTab(this)
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Widgets/ChcTabPane.vue